import {animate, AnimationTriggerMetadata, keyframes, state, style, transition, trigger} from '@angular/animations';

export const inOutList = trigger('inOutList', [
  state('ready', style({opacity: 1})),
  transition('void => ready', animate('400ms 0s ease-in', keyframes([
    style({opacity: 0, transform: 'translateX(-30px)', offset: 0}),
    style({opacity: 0.8, transform: 'translateX(10px)', offset: 0.8}),
    style({opacity: 1, transform: 'translateX(0px)', offset: 1})
  ]))),
  transition('ready => void', animate('300ms 0s ease-out', keyframes([
    style({opacity: 1, transform: 'translateX(0px)', offset: 0}),
    style({opacity: 0.8, transform: 'translateX(-10px)', offset: 0.2}),
    style({opacity: 0, transform: 'translateX(30px)', offset: 1})
  ])))
]);

export const detailExpand = trigger('detailExpand', [
  state('expanded', style({overflow: 'hidden', height: '*'})),
  state('collapsed', style({opacity: '0', overflow: 'hidden', height: '0px', 'padding-bottom': '0', 'padding-top': '0'})),
  transition('expanded <=> collapsed', animate('500ms ease-in-out'))
]);

export const rotatedState = trigger('rotatedState', [
  state('default', style({ transform: 'rotate(0)' })),
  state('rotated', style({ transform: 'rotate(90deg)' })),
  transition('rotated <=> default', animate('500ms ease-out')),
]);

export const easeInOut = trigger('easeInOut', [
  state('in', style({opacity: '1', display: 'block'})),
  state('out', style({opacity: '0', display: 'none'})),
  transition('in <=> out', animate('500ms ease-in-out'))
]);

export const slide = trigger('slide', [
  state('ready', style({opacity: 1})),
  transition('void => ready', animate('400ms 0s ease-in', keyframes([
    style({ transform: 'translateY(-30px)'}),
    style({ transform: 'translateY(10px)'}),
    style({ transform: 'translateY(0px)'})
  ]))),
  transition('ready => void', animate('300ms 0s ease-out', keyframes([
    style({ transform: 'translateY(0px)'}),
    style({ transform: 'translateY(-10px)'}),
    style({ transform: 'translateY(30px)'})
  ])))
]);

export const matTabsAnimations: {
  readonly translateTab: AnimationTriggerMetadata;
} = {
  /** Animation translates a tab along the X axis. */
  translateTab: trigger('translateTab', [
    // Note: transitions to `none` instead of 0, because some browsers might blur the content.
    state('center, void, left-origin-center, right-origin-center', style({transform: 'none'})),

    // If the tab is either on the left or right, we additionally add a `min-height` of 1px
    // in order to ensure that the element has a height before its state changes. This is
    // necessary because Chrome does seem to skip the transition in RTL mode if the element does
    // not have a static height and is not rendered. See related issue: #9465
    state('left', style({transform: 'translate3d(-100%, 0, 0)', minHeight: '1px'})),
    state('right', style({transform: 'translate3d(100%, 0, 0)', minHeight: '1px'})),

    transition('* => left, * => right, left => center, right => center',
      animate('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')),
    transition('void => left-origin-center', [
      style({transform: 'translate3d(-100%, 0, 0)'}),
      animate('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')
    ]),
    transition('void => right-origin-center', [
      style({transform: 'translate3d(100%, 0, 0)'}),
      animate('{{animationDuration}} cubic-bezier(0.35, 0, 0.25, 1)')
    ])
  ])
};
